import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { urls } from '../../js/Lib/API';
import {baseURL} from "../../js/Axios/Axios";

const FavoritSections = () => {
    const [data, setData] = useState([]);
    const fetchFavoriteSections = async () => {
        try {
            const response = await axios.get(urls.home.productCategoryStore);
            setData(
                response.data.data
            ); // Convert is_favorite to boolean
        } catch (err) {
            console.log('Error fetching favorite sections:', err);
        }
    };
    useEffect(() => {
        fetchFavoriteSections();
    }, []);

    return (
        <div>
            <div className='grid grid-cols-5 gap-4'>
                {data?.map((item, index) => {
                    const setcategory_id = item.id;
                    const handleSwitchChange = async (index) => {
                        if (data[index]) {
                            const newData = [...data];
                            newData[index].is_favorite = !newData[index].is_favorite;
                            setData(newData);
                            try {
                                await updateFavoriteSection(newData[index].category_id, newData[index].is_favorite);
                            } catch (err) {
                                console.log('Error updating favorite section:', err);
                            }
                        }
                    };

                    const updateFavoriteSection = async (category_id, is_favorite) => {
                        try {
                            await axios.post(`${baseURL}/Store/favorite_category`, {
                                category_id: setcategory_id,
                                is_favorite: is_favorite ? 1 : 0,
                            });
                        } catch (err) {
                            console.log('Error updating favorite category:', err);
                        }
                    };
                    return (
                        <div key={item.id} className='flex flex-col items-center bg-f2f2f2 p-2 rounded-xl gap-4'>
                            <div className='relative h-24 w-24'>
                                <img src={item?.media_link} className='absolute mix-blend-color-burn object-contain h-full w-full' alt={item.title} />
                            </div>
                            <p className='text-center text-2E2725'>{item.title}</p>
                            <button
                                type='button'
                                onClick={() => handleSwitchChange(index)}
                                className={`${item.is_favorite ? 'bg-00589c' : 'bg-gray-300'
                                    } relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none`}
                            >
                                <span
                                    className={`${item.is_favorite ? '-translate-x-6' : '-translate-x-1'
                                        } inline-block w-4 h-4 transform bg-white rounded-full transition-transform`}
                                />
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FavoritSections;
